// noinspection JSUnusedGlobalSymbols,JSUnresolvedReference

export class Category {
    constructor({id, name, image, icon, deepLevel, productsQuantity, customDeepName, order, isEmpty, isVisible, createdAt, updatedAt, parents, focus, featuredFilters, children, guidedSelling}) {
        this.id = id;
        this.name = name;
        this.image = image;
        this.icon = icon;
        this.deepLevel = deepLevel;
        this.productsQuantity = productsQuantity;
        this.customDeepName = customDeepName;
        this.order = order;
        this.isEmpty = isEmpty;
        this.isVisible = isVisible;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.parents = parents;
        this.focus = focus;
        this.featuredFilters = featuredFilters;
        this.children = children;
        this.guidedSelling = guidedSelling;
    };

    clone() {
        return new Category({
            id: this.id,
            name: this.name,
            image: this.image,
            icon: this.icon,
            deepLevel: this.deepLevel,
            productsQuantity: this.productsQuantity,
            customDeepName: this.customDeepName,
            order: this.order,
            isEmpty: this.isEmpty,
            isVisible: this.isVisible,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
            parents: this.parents,
            focus: this.focus,
            featuredFilters: this.featuredFilters,
            children: this.children,
            guidedSelling: this.guidedSelling
        });
    };
}

export const categoryConverter = {
    toFirestore() {
        return null;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        return new Category({
            id: snapshot.id,
            name: data.label || data.name,
            image: data.image,
            icon: data.icon,
            deepLevel: data.deep_level,
            productsQuantity: data.products_quantity || 0,
            customDeepName: data.custom_deep_name,
            order: data.order,
            isEmpty: data.is_empty,
            isVisible: data.is_visible,
            createdAt: data.created_at,
            updatedAt: data.updated_at,
            parents: data.parents,
            focus: false,
            featuredFilters: data.featured_filters || [],
            guidedSelling: data.guided_selling && data.guided_selling.length > 0 ? data.guided_selling.map((question) => new Question({
                title: question.title,
                description: question.description,
                order: question.order,
                filterId: question.filter_id
            })) : [],
            children: []
        });
    }
};

export class Question {
    constructor({title, description, order, filterId}) {
        this.title = title;
        this.description = description;
        this.order = order;
        this.filterId = filterId;
        this.filter = null;
    };

    clone() {
        return new Question({
            title: this.title,
            description: this.description,
            order: this.order,
            filterId: this.filterId,
            filter: this.filter
        });
    };
}
